import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Rink, Text } from '../components';

const containerBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.peta};
`;

const Container = styled('div')(containerBaseStyles);

const questionRowBaseStyles = ({ theme }) => css`
  color: ${theme.colors.b500};
  display: flex;
  margin: ${theme.spacings.bit} 0;
`;

const QuestionRow = styled('div')(questionRowBaseStyles);

const questionOperatorBaseStyles = ({ theme }) => css`
  margin-left: ${theme.spacings.mega};
  text-align: left;
  width: 70%;
`;

const QuestionOperator = styled('div')(questionOperatorBaseStyles);

const questionOperationBaseStyles = ({ theme }) => css`
  margin: 0 ${theme.spacings.bit};
  text-align: left;
  width: 30%;
`;

const QuestionOperation = styled('div')(questionOperationBaseStyles);

const QuizQuestion = ({ question }) => (
  <Container>
    <Rink>
      {question.map(({ id, operator, operation }) => (
        <QuestionRow key={id}>
          <QuestionOperator>
            <Text as='h3' size='mega' bold heading noMargin>
              {operator}
            </Text>
          </QuestionOperator>
          <QuestionOperation>
            <Text as='h3' size='mega' bold heading noMargin>
              {operation}
            </Text>
          </QuestionOperation>
        </QuestionRow>
      ))}
    </Rink>
  </Container>
);

QuizQuestion.propTypes = {
  question: PropTypes.array,
};

QuizQuestion.defaultProps = {
  question: [
    {
      id: `multiply`,
      operator: 'Multiply',
      operation: '6x2',
    },
    {
      id: `divide`,
      operator: 'Divide By',
      operation: 3,
    },
    {
      id: `add`,
      operator: 'Add',
      operation: 1,
    },
    {
      id: `subtract`,
      operator: 'Subtract',
      operation: 4,
    },
  ],
};

export default QuizQuestion;
